import { render, staticRenderFns } from "./OnHoldLabel.vue?vue&type=template&id=7e5e61c3&scoped=true&functional=true&"
import script from "./OnHoldLabel.vue?vue&type=script&lang=ts&"
export * from "./OnHoldLabel.vue?vue&type=script&lang=ts&"
import style0 from "./OnHoldLabel.vue?vue&type=style&index=0&id=7e5e61c3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "7e5e61c3",
  null
  
)

export default component.exports